// network.service.ts
import { Injectable, NgZone } from '@angular/core';
import { BehaviorSubject, fromEvent, merge, of } from 'rxjs';
import { mapTo, startWith } from 'rxjs/operators';

@Injectable({ providedIn: 'root' })
export class NetworkService {
  private onlineStatus$ = new BehaviorSubject<boolean>(navigator.onLine);

  constructor(private ngZone: NgZone) {
    this.monitorConnection();
  }

  private monitorConnection() {
    this.ngZone.runOutsideAngular(() => {
      merge(
        fromEvent(window, 'online').pipe(mapTo(true)),
        fromEvent(window, 'offline').pipe(mapTo(false)),
      )
        .pipe(startWith(navigator.onLine))
        .subscribe((status) => {
          this.ngZone.run(() => this.onlineStatus$.next(status));
        });
    });
  }

  get isOnline$() {
    return this.onlineStatus$.asObservable();
  }
}
